import { LookupRow, EventTypeLookupRow } from '../lookup-types';
import { SubLookupType, EventType } from '@rcp/types';
import { ILookupDataConverter } from './lookup-data-converter';
import _ from 'lodash';

export class LookupRowInspectionTypeValueConverter implements ILookupDataConverter {
	subLookupType: SubLookupType;
	constructor(subLookupType: SubLookupType) {
		this.subLookupType = subLookupType;
	}

	toAPIAddDataFromLookups = (existingLookupRows: EventTypeLookupRow[], newValue: EventTypeLookupRow): EventType => {
		let dataToPost = {
			eventTypeAbbreviation: newValue.code,
			eventTypeDescription: newValue.codeDescription,
			eventCategory: this.subLookupType,
			eventCategoryId: newValue.eventCategoryId,
			schedulingFrequencyId: newValue.schedulingFrequencyId,
			useFrequencyAssignedToFacility: newValue.useFrequencyAssignedToFacility
		} as EventType;

		return dataToPost;
	};

	toAPIDeleteDataFromLookups = (existingRows: EventTypeLookupRow[], rowToDelete: EventTypeLookupRow): EventType => {
		return rowToDelete;
	};

	toAPIUpdateDataFromLookups = (existingRows: EventTypeLookupRow[], rowToUpdate: EventTypeLookupRow): EventType => {
		let dataToUpdate: EventType = {
			eventTypeId: rowToUpdate.lookupId,
			eventTypeAbbreviation: rowToUpdate.code,
			eventTypeDescription: rowToUpdate.codeDescription,
			eventCategory: this.subLookupType,
			eventCategoryId: rowToUpdate.eventCategoryId,
			schedulingFrequencyId: rowToUpdate.schedulingFrequencyId,
			useFrequencyAssignedToFacility: rowToUpdate.useFrequencyAssignedToFacility,
			isActive: rowToUpdate.isActive
		};
		return dataToUpdate;
	};

	toLookupRowsFromAPI = (apiData: any): LookupRow[] => {
		let lookupValues: EventTypeLookupRow[] = [];
		if (apiData && _.isArray(apiData)) {
			let events = apiData as EventType[];
			events = events.filter(i => i.eventCategory === this.subLookupType);
			lookupValues = events.map((i: EventType) => {
				return {
					lookupId: i.eventTypeId,
					code: i.eventTypeAbbreviation,
					codeDescription: i.eventTypeDynamicDescription,
					isActive: i.isActive,
					isInUse: i.isInUse
				} as EventTypeLookupRow;
			});
		}
		return lookupValues as LookupRow[];
	};

	toLookupRowFromAPI = (apiData: any): LookupRow => {
		let eventType = apiData as EventType;
		return {
			lookupId: eventType.eventTypeId,
			code: eventType.eventTypeAbbreviation,
			codeDescription: eventType.eventTypeDynamicDescription,
			isActive: eventType.isActive,
			isInUse: eventType.isInUse
		} as LookupRow;
	};
}
